import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';

import ThumbnailsItem from '../../../../components/Editor/Thumbnails/ThumbnailsItem';
import { getPageHtmlPath } from '../../utils/helpers';
import UrlUtils from '../../../../utils/url';
import SelectionManager from '../../../../utils/selectionManager';
import DriveItemUtils from '../../../../utils/driveItem';
import { EditorType } from '../../constants';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		routerParamsHistory,
		galleryInfos: { config: galleryConfig },
		editor: {
			type: editorType,
			thumbnails,
			slider: { page, totalPages },
			configs: { generalData: { editablePublication: editableData } },
			paths: { thumbnailPath },
			version,
			pageSelection,
		},
		driveList: { driveItems, resolutions },
	} = state;
	const { params: { resourceId } } = routerParamsHistory[routerParamsHistory.length - 1];
	const { position, activeDraggingPosition } = ownProps;
	const {
		label,
		type,
		fileType,
		proposal,
	} = thumbnails[position - 1];

	const isActive = pageSelection.isActive
		? pageSelection.pages.includes(position)
		: position === page;

	return {
		...ownProps,
		label,
		type,
		fileFormat: fileType,
		imageSrc: editorType === EditorType.HTML
			? DriveItemUtils.getThumbnail(driveItems[resourceId], galleryConfig, resolutions, false)
			: UrlUtils.getEditorResourceUrl(galleryConfig, +resourceId, `${getPageHtmlPath(thumbnailPath, position)}?version=${version}`),
		isProposal: proposal,
		isActive,
		isEditable: Object.keys(editableData).includes(position.toString()),
		isPageSelectionActive: pageSelection.isActive,
		selectedPagesNumber: isActive ? pageSelection.pages.length : undefined,
		activeDraggingPosition: isActive ? activeDraggingPosition : null,
		isAllPagesSelected: pageSelection.pages.length === totalPages,
		isGapInSelectedPages: isActive && SelectionManager.isGapInSelectedItems(pageSelection.pages),
		isPageSelectionAvailable: totalPages > 1,
	};
};

export default connect(mapStateToProps)(ThumbnailsItem);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/Thumbnails/ThumbnailsItem/index.tsx